module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099FVTTMX.b7fcd574.jpg";